import { render } from "./ComparisionQuote.vue?vue&type=template&id=2c2cc366&scoped=true"
import script from "./ComparisionQuote.vue?vue&type=script&lang=js"
export * from "./ComparisionQuote.vue?vue&type=script&lang=js"

import "./ComparisionQuote.vue?vue&type=style&index=0&id=2c2cc366&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2cc366"]])

export default __exports__